import { defineMessages } from 'react-intl';

export default defineMessages({
  charityVettingArretePublicationDateTitleFR: {
    id: 'charity.vetting.fr.arrete.publication.date.title',
    defaultMessage: 'What is the date of your "arrêté"?',
  },
  charityVettingArretePublicationDateLabelFR: {
    id: 'charity.vetting.fr.arrete.publication.date.label',
    defaultMessage: 'Date of "arrêté"',
  },
  charityVettingArretePublicationDateRequiredFR: {
    id: 'charity.vetting.fr.arrete.publication.date.required',
    defaultMessage: 'Please provide the date of your "arrêté"',
  },
});

// French legal subtitle — not wrapped in defineMessages to prevent i18n extraction
export const frenchOptions = {
  charityVettingArretePublicationDateSubtitleFR: {
    id: 'charity.vetting.fr.arrete.publication.date.subtitle',
    defaultMessage:
      "Association située dans le département de la Moselle, du Bas-Rhin ou du Haut-Rhin dont la mission a été reconnue d'utilité publique",
  },
} as const;
